import React from "react";
import emailjs from "emailjs-com";

export default function Contact() {
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm(
      "service_6qxz1ao",
      "template_7owhrvv", // template for admin
      e.target,
      "QqO7mxIBm9KqGTQ6l", // from EmailJS dashboard
    );

    emailjs
      .sendForm(
        "service_6qxz1ao", // from EmailJS dashboard
        "template_upulftl", // from EmailJS dashboard
        e.target,
        "QqO7mxIBm9KqGTQ6l", // from EmailJS dashboard
      )
      .then(
        () => alert("Message sent successfully!"),
        () => alert("Failed to send message. Please try again."),
      );

    e.target.reset(); // clear form after submit
  };

  return (
    <section id="contact" className="contact-section">
      <h2 className="contact-heading">Let's Find Your Perfect Match</h2>
      <div className="contact-container">
        {/* Left side: contact details */}
        <div className="contact-details">
          <div className="detail-item">
            <span className="detail-icon">📞</span>
            <p>068 159 3340</p>
          </div>
          <div className="detail-item">
            <span className="detail-icon">✉️</span>
            <p>carfinderssa@gmail.com</p>
          </div>
          <div className="detail-item">
            <span className="detail-icon">🌐</span>
            <p>www.carfinderssa.co.za</p>
          </div>
        </div>

        {/* Right side: EmailJS form */}
        <form className="contact-form" onSubmit={sendEmail}>
          <input type="text" name="name" placeholder="Full Name" required />
          <input
            type="text"
            name="contact_number"
            placeholder="Contact Number"
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Email Address"
            required
          />
          <input
            type="text"
            name="vehicle"
            placeholder="Vehicle Interested In"
          />
          <input type="text" name="budget" placeholder="Budget Range" />
          <textarea name="message" placeholder="Message"></textarea>
          <button className="primary" type="submit">
            Submit
          </button>
        </form>
      </div>
    </section>
  );
}
